import React, { useEffect, useRef, useState } from "react";
import { parseUntilObject } from "../../utilities/conversions";
import axios from "axios";
import { useParams } from "react-router-dom";

/**
 * VcomJitsi.jsx
 *
 * Full single-file React component converted from the provided PHP/HTML page.
 * - No PHP; all server values are passed in via props
 * - Dynamically loads the Jitsi external_api script
 * - Uses a WebSocket for realtime messages
 * - Implements the same modals, timer, and behaviours as the original page
 *
 * Props (all optional — defaults provided):
 * - callDetail: { id, cid, duration }
 * - agent: { uid, name }
 * - metaValue: { alert_minutes_before, alert_beep_message }
 * - footerSettings: { fav_icon }
 * - serverName: hostname string (e.g. "example.com" or "localhost")
 * - apiBase: base URL string for REST endpoints (e.g. "https://example.com/")
 * - jitsiDomain: domain that serves external_api.js (default: 'vcom.jablabla.com')
 *
 * Important: Replace fetch endpoints (update-status, getCallDetail) with working endpoints
 * in your environment. This component does not depend on jQuery or Bootstrap.
 */
export default function VcomAgentBookingCall({
    baseUrl,
    currentUser,
    // callDetail = { id: 123, cid: "meeting-123", duration: 15 },
    // agent = { uid: 42, name: "Agent" },
    // metaValue = { alert_minutes_before: 1, alert_beep_message: "/assets/ringtone.mp3" },
    // footerSettings = { fav_icon: "favicon.ico" },
    // serverName = typeof window !== 'undefined' ? window.location.hostname : 'localhost',
    // apiBase = '/',
    // jitsiDomain = 'vcom.jablabla.com',
}: { baseUrl: string, currentUser: any }) {
    // refs and state
    const jitsiDomain = 'vcom.jablabla.com';
    const { eventKey } = useParams<{ eventKey: string }>();
    const [callDetail, setCallDetail] = useState<any>(null);
    const [agent, setAgent] = useState<any>(null);
    const [customer, setCustomer] = useState<any>(null);
    const [alertBeepMessage, setAlertBeepMessage] = useState("");
    const [alertMinutesBefore, setAlertMinutesBefore] = useState(1);
    const [loading, setLoading] = useState(true);


    const jitsiContainerRef = useRef<HTMLDivElement>(null);
    const apiObjRef = useRef(null);
    const wsRef = useRef<WebSocket | undefined>(null);
    const timerRef = useRef<number | undefined>(undefined);
    const [meetingDurationText, setMeetingDurationText] = useState(() => localStorage.getItem('meetingDuration') || null);
    const [isWaitingModalOpen, setWaitingModalOpen] = useState(true);
    const [isHoldModalOpen, setHoldModalOpen] = useState(false);
    const [isAddedMinutesModalOpen, setAddedMinutesModalOpen] = useState(false);
    const [addedMinutesText, setAddedMinutesText] = useState('');

    const [maxDuration, setMaxDuration] = useState(0);
    const [onceAlerted, setOnceAlerted] = useState(false);
    const musicRef = useRef(new Audio(alertBeepMessage || 'https://chamcore.com/chameleon/assets/ringtone.mp3'));

    /** Fetch call details by eventKey */
    const fetchBooking = async () => {
        try {
            const res = await axios.get(`${baseUrl}/getBookingDetailAndInsertCall`, {
                params: { event_key: eventKey, token: currentUser?.token },
            });
            setCallDetail(res.data.callDetail);
            setAgent(res.data.agent);
            setCustomer(res.data.customer);
            setAlertBeepMessage(res.data.alert_beep_message);
            setAlertMinutesBefore(res.data.alert_minutes_before);
            setMaxDuration(res.data.callDetail.duration);
        } catch (err) {
            console.error("Error fetching call:", err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {


        if (eventKey) fetchBooking();
    }, [eventKey, baseUrl, currentUser?.token]);

    // Build websocket url similar to the original: ws://host:8013/echo (localhost) or wss://wss.host/echo
    function getWsUrl() {
        if (baseUrl.includes("localhost")) {
            return `ws://localhost:8013/echo`;
        }
        return `wss://wss.chamcore.com/echo`;
    }

    // WebSocket message handler
    function handleWsMessage(raw: any) {
        if (!raw) return;
        let data;
        try {
            data = parseUntilObject(raw);
        } catch (err) {
            // ignore invalid messages
            return;
        }

        // only act on messages for this agent
        if (String(data?.information?.agent_id) !== String(agent.uid)) return;

        switch (data.about) {
            // case 'trigger_pause':
            //     setHoldModalOpen(true);
            //     break;
            // case 'added_more_minutes':
            //     console.log("🟢 Entered case: added_more_minutes");
            //     console.log("📦 Data object:", data);
            //     console.log("🌐 baseUrl:", baseUrl);
            //     console.log("🔑 Token:", currentUser?.token);
            //     // fetch updated call detail from API (replace endpoint as needed)
            //     axios.get(`${baseUrl}/getCallDetail`, { params: { call_id: data.call_history_id, token: currentUser?.token } }).then(response => {
            //         if (response.data.status === 'OK') {
            //             setHoldModalOpen(false);
            //             setMaxDuration(parseFloat(alertMinutesBefore.toString()) + parseFloat(response.data.callDetail.duration));
            //             setAddedMinutesText(`Customer added ${response.data.callDetail.duration} minutes to the call`);
            //             setAddedMinutesModalOpen(true);

            //             // restart the timer at 0 (behaviour from original code)
            //             startTimer(0);
            //         } else {
            //             console.log(response);
            //         }
            //     }).catch((error) => {
            //         console.error("❌ Axios Error:", error);
            //     });
            //     break;

            // case 'cancelled_more_minutes':
            //     setHoldModalOpen(false);
            //     break;
            case 'end_booking_call_now':
                localStorage.removeItem('meetingDuration');
                updateAgentStatus();
                break;
            default:
                break;
        }
    }

    // updateAgentStatus: mirrors the AJAX call in original code
    async function updateAgentStatus() {
        const call_status = 'available';
        const agent_uid = agent.uid;
        try {
            var formData = new FormData();
            formData.append("agent_uid", agent_uid);
            formData.append("call_status", call_status);
            const resp = await axios.post(`${baseUrl}/updateAgentStatus`, formData);
            if (resp.data.status === 'OK' || resp.data.code === 200) {
                // clear jitsi area and close window as original
                if (jitsiContainerRef.current) {
                    jitsiContainerRef.current.innerHTML = "<h1 style='color: white;display:flex;align-items:center;justify-content:center;height:50vh'>The call has been over. Thank you for reaching out.</h1>";
                }
                localStorage.removeItem('meetingDuration');
                // attempt to close window (may be blocked by browsers)
                try { window.close(); } catch (e) { /* ignore */ }
            }
        } catch (e) {
            // ignore failures
        }
    }

    // Timer logic (stores mm:ss in localStorage meetingDuration)
    function startTimer(initialSeconds = 0) {
        if (timerRef.current !== undefined) {
            clearTimeout(timerRef.current);
        }
        let cnt = parseInt(initialSeconds.toString(), 10) || 0;

        function tick() {
            cnt += 1;
            const hours = Math.floor(cnt / 3600);
            const minutes = Math.floor((cnt / 60) % 60);
            const seconds = cnt % 60;
            const hh = hours < 10 ? '0' + hours : String(hours);
            const mm = minutes < 10 ? '0' + minutes : String(minutes);
            const ss = seconds < 10 ? '0' + seconds : String(seconds);

            const timeeee = `${mm}:${ss}`;
            localStorage.setItem('meetingDuration', timeeee);
            setMeetingDurationText(timeeee);

            // if ((parseInt(maxDuration.toString(), 10) - parseInt(alertMinutesBefore.toString(), 10)) === minutes && !onceAlerted) {
            //     // show about-to-end modal & sound beep
            //     setOnceAlerted(true);
            //     musicRef.current.play().catch(() => { /* autoplay may be blocked */ });
            // }

            // continue
            timerRef.current = setTimeout(tick, 1000);
        }
        timerRef.current = setTimeout(tick, 1000);
    }

    // Load Jitsi external_api.js dynamically
    function loadJitsiScript() {
        return new Promise((resolve, reject) => {
            if (window.JitsiMeetExternalAPI) return resolve(window.JitsiMeetExternalAPI);
            const src = `https://${jitsiDomain}/external_api.js`;
            const s = document.createElement('script');
            s.src = src;
            s.async = true;
            s.onload = () => resolve(window.JitsiMeetExternalAPI);
            s.onerror = reject;
            document.head.appendChild(s);
        });
    }

    // Start Jitsi meeting with options
    async function startMeeting(meetingId: string, dispName: string) {
        if (!meetingId) return;
        try {
            const Jitsi = await loadJitsiScript();
            const toolbarButtons = [
                'camera',
                'hangup',
                'microphone',
                'toggle-camera',
            ]
            const options = {
                roomName: meetingId,
                width: '100%',
                height: '100%',
                parentNode: jitsiContainerRef.current,
                userInfo: { displayName: dispName },
                configOverwrite: {
                    notifications: [], // we'll disable selectively below
                    disableDeepLinking: true,
                    prejoinPageEnabled: false,
                    enableWelcomePage: false,
                    disableTileView: false,
                    toolbarButtons: toolbarButtons,
                    buttonsWithNotifyClick: [
                        'end-meeting',
                        'hangup',
                        'hangup-menu'
                    ]
                },
                interfaceConfigOverwrite: {
                    TOOLBAR_ALWAYS_VISIBLE: true,
                },
            };

            // create the Jitsi object
            const api = new Jitsi(jitsiDomain, options);
            apiObjRef.current = api;

            // plain equivalent of the event listeners used in the original
            api.addListener('videoConferenceJoined', () => {
                // nothing to do straight away in our conversion — placeholder
                api.executeCommand('toggleTileView');
            });

            api.addEventListeners({
                readyToClose: () => {
                    // placeholder: original code updated agent status on meeting end
                },
                participantJoined: (data: any) => {
                    setWaitingModalOpen(false);

                    // restore timer if localStorage value exists
                    const ld = localStorage.getItem('meetingDuration');
                    if (ld) {
                        const parts = ld.split(':');
                        if (parts.length === 2) {
                            const minutes = parseInt(parts[0], 10);
                            const seconds = parseInt(parts[1], 10);
                            const totalSeconds = (minutes * 60) + seconds;
                            startTimer(totalSeconds);
                            return;
                        }
                    }
                    startTimer(0);
                },
                toolbarButtonClicked: (object: any) => {
                    const key = object?.key;
                    if (key === 'end-meeting' || key === 'hangup' || key === 'hangup-menu') {
                        localStorage.removeItem('meetingDuration');
                        const data = {
                            call_history_id: callDetail.id,
                            about: 'end_booking_call_now',
                            channel: 'common_channel',
                            type: 'video_call',
                        };
                        // send via websocket if open
                        try { wsRef.current?.send(JSON.stringify(data)); } catch (e) { }
                        updateAgentStatus();
                    }
                }
            });

        } catch (err) {
            console.error('Failed to load Jitsi API', err);
        }
    }

    useEffect(() => {
        // set document title and favicon (mirrors PHP <title> and favicon usage)
        // document.title = `MysticConnect VCOM`;

        // open waiting modal on mount
        setWaitingModalOpen(true);

        // WebSocket connect
        const wsUrl = getWsUrl();
        try {
            const conn = new WebSocket(wsUrl);
            wsRef.current = conn;
            conn.onmessage = (e) => handleWsMessage(e.data);
        } catch (e) {
            console.warn('WebSocket connection failed', e);
        }

        // start jitsi
        const dispName = agent?.name || 'Participant';
        startMeeting(callDetail?.cid, dispName);

        // When the component unmounts cleanup
        return () => {
            try { apiObjRef.current?.dispose(); } catch (e) { }
            try { wsRef.current?.close(); } catch (e) { }
            clearTimeout(timerRef.current);
        };
    }, [callDetail, agent]); // run once

    // Small helper: human-friendly display of agent name
    const [showAgentName, setShowAgentName] = useState('Agent');

    useEffect(() => {
        setShowAgentName(agent?.name);
    }, [agent])

    if (loading) {
        return (
            <div className="flex items-center justify-center h-screen text-white">
                Loading call...
            </div>
        );
    }

    if (!callDetail) {
        return (
            <div className="flex items-center justify-center h-screen text-red-500">
                Call not found
            </div>
        );
    }

    // UI: simple Tailwind-based modals and Jitsi container
    return (
        <div className="min-h-screen bg-black text-white">
            <div ref={jitsiContainerRef} style={{ height: '97.7vh' }} id="jitsi-meet-conf-container" />

            {/* Waiting Participant Modal */}
            {isWaitingModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div className="absolute inset-0 bg-black/60" onClick={() => { }} />
                    <div className="relative bg-orange-400 rounded-lg p-6 w-80">
                        <div className="flex flex-col items-center">
                            <img src="https://placeimg.com/400/400/people" alt="avatar" className="rounded-full w-32 h-32" />
                            <p id="in_video_call" className="text-black text-center mt-4">Please hold<br />we are connecting</p>
                            <p className="text-black text-center mt-2 font-semibold" id="show_name">{showAgentName}</p>
                            <div className="w-full text-center my-4">
                                <div className="inline-block animate-spin border-4 border-transparent border-t-black rounded-full w-10 h-10" />
                            </div>
                            <div className="text-center">
                                <button className="bg-red-600 text-white px-4 py-2 rounded-full" onClick={() => setWaitingModalOpen(false)}>Hide</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Hold The Line Modal */}
            {isHoldModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div className="absolute inset-0 bg-black/60" />
                    <div className="relative bg-orange-400 rounded-lg p-6 w-80">
                        <div className="flex flex-col items-center">
                            <img src="https://placeimg.com/400/400/people" alt="avatar" className="rounded-full w-32 h-32" />
                            <input type="hidden" id="video_call_id" value={callDetail.id} />
                            <div id="buy_more_minutes_text" className="text-black text-center mt-4">Please <br /> hold the line.</div>
                            <div className="w-full text-center my-4">
                                <div className="inline-block animate-spin border-4 border-transparent border-t-black rounded-full w-10 h-10" />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Added More Minutes Modal */}
            {isAddedMinutesModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div className="absolute inset-0 bg-black/60" onClick={() => setAddedMinutesModalOpen(false)} />
                    <div className="relative bg-gray-800 rounded-lg p-6 w-80">
                        <div className="flex flex-col items-center">
                            <h3 className="text-white">..</h3>
                            <p id="added-more-minutes-text" className="text-center text-white mt-4">{addedMinutesText}</p>
                            <div className="mt-4">
                                <button className="bg-blue-600 px-4 py-2 rounded" onClick={() => setAddedMinutesModalOpen(false)}>OK</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Small hidden styles replicated from original */}
            <style>{`
        span[data-role="remove"]::after { content: "x" !important; top: -8px !important; padding-left: 10px !important; }
        .notifications-container { display: none !important; }
      `}</style>
        </div>
    );
}
